import React, { Component } from "react";
import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";
// import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { Container, Card, Table } from "react-bootstrap";
import * as constants from "../../../constants";
import { connect } from 'react-redux';
import { productivityServices } from "./Productivity.services";
import MultiSelect from "react-multi-select-component";
import { commonServices } from "../../../commonServices/commonServices";
// import FilterComponent from "../../../partials/layout/FilterComponent";

class Leaderboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            page: 1,
            total: undefined,
            offset: 0,
            limit: 10,
            leaderboardData: [],
            selectedMonth: new Date().getMonth() + 1,
            selectedYear: new Date().getFullYear(),
            formattedCities: [],
            selectedCities: []
        };
    }

    componentDidMount() {
        this.getLeaderboard();
        this.getCities();
    }

    handleMonthYearChange = async (e) => {
        const [month, year] = e.target.value.split("-");

        await this.setState({
            selectedMonth: Number(month),
            selectedYear: Number(year)
        });

        this.getLeaderboard();
    };

    generateMonthYearOptions = () => {
        const options = [];
        const today = new Date();

        for (let i = 0; i < 12; i++) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);

            const month = d.getMonth() + 1;
            const year = d.getFullYear();

            const label = d.toLocaleString("default", {
                month: "long",
                year: "numeric"
            });

            options.push(
                <option key={`${month}-${year}`} value={`${month}-${year}`}>
                    {label}
                </option>
            );
        }

        return options;
    };

    getCities = async () => {
        const data = { pmsOperationStatus: "YES" };

        const result = await commonServices.getCities(data);

        if (result && result.status === 200) {
            const cities = result?.data?.cities || [];

            const formattedCities = commonServices.formatCities(cities);

            this.setState({
                formattedCities
            });
        }
    };

    setSelected = (selectedCities) => {
        this.setState({ selectedCities }, () => {
            this.getLeaderboard();
        });
    };
    getLeaderboard = async () => {
        this.setState({ isFetching: true });

        const { selectedMonth, selectedYear, limit, offset, selectedCities } = this.state;

        const params = {
            month: selectedMonth,
            year: selectedYear,
            limit, offset,
            cityIds: selectedCities.map(c => c.value)
        };

        const result = await productivityServices.getLeaderboard(params);
        const totalCount = result.headers['x-total-count'];
        const totalPageNo = Math.ceil(result.headers['x-total-count'] / limit);
        if (result && result.status === 200) {
            this.setState({
                leaderboardData: result.data || [],
                total: (totalPageNo === 0) ? 1 : totalPageNo,
                totalCount
            });
        }

        this.setState({ isFetching: false });
    };
    onPageChange = async (page) => {
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        await this.getLeaderboard();
    }

    resetPage = async () => {
        await this.setState({
            page: 1,
            offset: 0,
            //limit: 10,
        });
    }
    handleFilterChildData = async (childData) => {
        if (childData) {
            this.setState({ ...childData })
            await this.resetPage();
            await this.getLeaderboard();
        }
    }
    getRankBadge = (rank) => {
        if (rank === 1) return <span className="rank gold">1</span>;
        if (rank === 2) return <span className="rank silver">2</span>;
        if (rank === 3) return <span className="rank bronze">3</span>;
        return <span className="rank normal">{rank}</span>;
    };

    getPayoutBadge = (payout) => {
        let className = "payout-badge ";

        if (payout === 100) className += "green";
        else if (payout === 75) className += "blue";
        else if (payout === 50) className += "orange";
        else className += "red";

        return <span className={className}>{payout}%</span>;
    };

    render() {
        const { leaderboardData, isFetching, total, page, totalCount } = this.state;
        let showPagination = false;
        if (total) { showPagination = total !== 0 && total !== 1; }

        return (
            <Container fluid>
                <Portlet fluidHeight>
                    <PortletHeader
                        title={`PM Leaderboard (${totalCount || 0})`}
                        toolbar={
                            <div className="leaderboard-toolbar">

                                <div className="toolbar-item">
                                    <MultiSelect className="form-control productivity-month-select"
                                        options={this.state.formattedCities || []}
                                        value={this.state.selectedCities || []}
                                        onChange={this.setSelected}
                                        labelledBy={"All Cities"}
                                    />
                                </div>


                                <div className="toolbar-item">
                                    <select
                                        className="form-control productivity-month-select"
                                        value={`${this.state.selectedMonth}-${this.state.selectedYear}`}
                                        onChange={this.handleMonthYearChange}
                                    >
                                        {this.generateMonthYearOptions()}
                                    </select>
                                </div>

                            </div>
                        }
                    />
                    <PortletBody>
                        <Card>
                            {/* <FilterComponent
                                recordsPerPage={constants.RECORDS_PER_PAGE}
                                selectedRecordValue={this.state.limit}
                                filterParentCallback={this.handleFilterChildData}
                            /> */}
                            <Card.Body>
                                {isFetching && <p>{constants.LOADING_DATA}</p>}

                                {!isFetching && (
                                    <Table hover responsive className="leaderboard-table">
                                        <thead>
                                            <tr>
                                                <th>Rank</th>
                                                <th>PM Name</th>
                                                {/* <th>City</th> */}
                                                <th>Props</th>
                                                <th>Total</th>
                                                <th>Ops (45)</th>
                                                <th>Fin (15)</th>
                                                <th>CX (20)</th>
                                                <th>Ren (20)</th>
                                                <th>Payout %</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {leaderboardData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{this.getRankBadge(item.rank)}</td>
                                                    <td className="name">{item.pmName}</td>
                                                    {/* <td>{item.city}</td> */}
                                                    <td>{item.properties}</td>
                                                    <td><strong>{item.total}</strong></td>
                                                    <td>{item.ops}</td>
                                                    <td>{item.fin}</td>
                                                    <td>{item.cx}</td>
                                                    <td>{item.ren}</td>
                                                    <td>{this.getPayoutBadge(item.payoutPercentage)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                )}
                            </Card.Body>
                        </Card>
                        {/* {showPagination && showPagination && < UltimatePagination
                            currentPage={page}
                            totalPages={total}
                            onChange={this.onPageChange}
                            boundaryPagesRange={0}
                            hidePreviousAndNextPageLinks={true}
                            hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                        />} */}
                    </PortletBody>
                </Portlet>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    userDetails: state.auth && state.auth.user
});

export default
    connect(
        mapStateToProps,
        null
    )(Leaderboard);